import IconOrderTypeCatering from '@/assets/icons/order-type/catering.svg'
import IconOrderTypeDelivery from '@/assets/icons/order-type/delivery.svg'
import IconOrderTypeG from '@/assets/icons/order-type/g.svg'
import IconOrderTypeOrderAtTable from '@/assets/icons/order-type/order-at-table.svg'
import IconOrderTypeParkAndCollect from '@/assets/icons/order-type/park-and-collect.svg'
import IconOrderTypePickup from '@/assets/icons/order-type/pickup.svg'

export interface RestaurantBookingProvider {
  type: RestaurantBookingProviderType
  'configValue1'?: string | null
  'configValue2'?: string | null
}

/** @format int32 */
export type RestaurantBookingProviderType = 1 | 2

export interface RestaurantHour {
  name: string
  description: string
  isClosed: boolean
}

export type OrderType = 100 | 101 | 102 | 103 | 104 | 105 | 106 | 107
export type OnlineOrderType = 100 | 102 | 103 | 106

export enum InStoreOrderTypeEnum {
  TAKE_AWAY = 101,
  DRIVE_THRU = 104,
  STAFF = 105,
  CATERING = 107
}

export enum OnlineOrderTypeEnum {
  ORDER_AT_TABLE = 100,
  PARK_AND_COLLECT = 102,
  DELIVERY = 103,
  PICKUP = 106
}

export const OrderTypeEnum = {
  ...InStoreOrderTypeEnum,
  ...OnlineOrderTypeEnum
}

type RestaurantTag = 'marketing'

export interface TagIcon {
  name: string
  icon: string
}

export const OrderTypeMapping: Record<OrderType, TagIcon> = {
  100: { name: 'Order At Table', icon: IconOrderTypeOrderAtTable },
  101: { name: 'Take Away', icon: IconOrderTypePickup },
  102: { name: 'Park & Collect', icon: IconOrderTypeParkAndCollect },
  103: { name: 'Delivery', icon: IconOrderTypeDelivery },
  104: { name: 'Drive Thru', icon: IconOrderTypeParkAndCollect },
  105: { name: 'Staff', icon: IconOrderTypeG },
  106: { name: 'Pick Up', icon: IconOrderTypePickup },
  107: { name: 'Catering', icon: IconOrderTypeCatering }
}

export interface LocalMatter {
  name: string
  description: string
  imageUrl: string | null
  groupAllocationId: string
  monthlyProgramId: string
}

export interface Restaurant {
  id: number
  name: string
  phoneNumber: string
  address: string
  latitude: number
  longitude: number
  description: string | null
  makeTimeInMinutes: number
  makeTimeMessage: string | null
  imageUrl: string | null
  differentiatorImageUrl: string | null
  timeZone: string
  openingTimeToday: string
  closingTimeToday: string
  isOnline: boolean
  hours: RestaurantHour[]
  orderTypes: OrderType[]
  localMatters: LocalMatter[] | null
  tags: Record<RestaurantTag, string[]> | null
  salesforceId: string | null
  obeeId: string | null
  bookingProvider?: RestaurantBookingProvider
  distanceInMetres: number | null
  slug: string | null
}
